import { accordion } from './accordion';
import { autocomplete } from './autocomplete';
import { backdrop } from './backdrop';
import { button } from './button';
import { buttonGroup } from './button-group';
import { card } from './card';
import { checkbox } from './checkbox';
import { dialog } from './dialog';
import { drawer } from './drawer';
import { formControl } from './form-control';
import { formLabel } from './form-label';
import { iconButton } from './icon-button';
import { input } from './input';
import { list } from './list';
import { menu } from './menu';
import { pagination } from './pagination';
import { paper } from './paper';
import { popover } from './popover';
import { radio } from './radio';
import { select } from './select';
import { slider } from './slider';
import { snackbar } from './snackbar';
import { stepper } from './stepper';
import { switchOverrides } from './switch';
import { tablePagination } from './table-pagination';
import { tabs } from './tabs';
import { toggleButton } from './toggle-button';
import { tooltip } from './tooltip';
import { typography } from './typography';

const overrides = () => {
  return Object.assign(
    {},
    accordion(),
    stepper,
    autocomplete(),
    backdrop,
    button,
    buttonGroup,
    card(),
    checkbox,
    dialog(),
    drawer(),
    formLabel,
    formControl,
    iconButton,
    input,
    list,
    menu(),
    pagination,
    paper,
    popover(),
    radio,
    select,
    slider,
    snackbar(),
    switchOverrides,
    tablePagination,
    tabs,
    toggleButton,
    tooltip,
    typography
  );
};

export { overrides };
